module.exports = __webpack_public_path__ + "img/failed_tip.61f10955.jpg";